// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","conteudo":"Header_conteudo__ZsZ7P","logo":"Header_logo__UsziS"};